const EMPLOYMENT_LABELS = {
  fulltime: 'Full-time',
  parttime: 'Part-time',
  casual: 'Casual',
  cash: 'Cash',
};

function compactKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function isEmploymentTypeValue(value) {
  return Boolean(EMPLOYMENT_LABELS[compactKey(value)]);
}

export function formatTypeOfWorkLabel(value) {
  const parts = String(value || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  for (const part of parts) {
    const label = EMPLOYMENT_LABELS[compactKey(part)];
    if (label) return label;
  }
  return '';
}

export function skillTagsFromStoredWork(value) {
  return String(value || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .filter((part) => !isEmploymentTypeValue(part));
}
